import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { authAxiosWithoutInterceptors } from "./axios";

export const useDoubleAuth = () => {
  const [state, execute, cancel] = authAxiosWithoutInterceptors<void, { _id: ObjectId; code: string }, unknown>({
    url: "/double-auth",
    method: "POST",
  });

  const callback = useCallback(
    (_id: ObjectId, code: string) => {
      return execute({
        data: {
          _id,
          code,
        },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
